import {createReducer, on} from '@ngrx/store';
import {ScenarioActions} from './scenario.actions';
import {initialState} from './scenario.state';

export const scenarioReducer = createReducer(
  initialState,

  on(ScenarioActions.public.updateScenarioFilter, (state, {filter}) => ({
    ...state,
    filter,
  })),

  on(ScenarioActions.private.loadScenariosWithFilters, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),

  on(ScenarioActions.private.loadScenariosSuccess, (state, {scenariosResponseDto}) => {
    const entities = {...state.entities};
    scenariosResponseDto.scenarios.forEach((it) => {
      entities[it.id] = it;
    });

    return {
      ...state,
      entities,
      pages: {
        ...state.pages,
        [state.filter.page ?? 0]: scenariosResponseDto.scenarios.map((it) => it.id),
      },
      totalCount: scenariosResponseDto.totalCount,
      isLoading: false,
      error: null,
    };
  }),

  on(ScenarioActions.private.loadScenariosFailure, (state, {error}) => ({
    ...state,
    isLoading: false,
    error,
  })),

  on(ScenarioActions.public.loadScenarioHistory, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),

  on(ScenarioActions.private.loadScenarioHistorySuccess, (state, {historyResponseDto}) => ({
    ...state,
    history: [...historyResponseDto.histories],
    isLoading: false,
    error: null,
  })),

  on(ScenarioActions.private.loadScenarioHistoryFailure, (state, {error}) => ({
    ...state,
    isLoading: false,
    error,
  })),

  on(ScenarioActions.public.runScenario, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),

  on(ScenarioActions.private.runScenarioSuccess, (state, {id, responseDto}) => ({
    ...state,
    isLoading: false,
    error: null,
  })),

  on(ScenarioActions.private.runScenarioFailure, (state, {error}) => ({
    ...state,
    isLoading: false,
    error,
  })),

  on(ScenarioActions.public.stopScenario, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),

  on(ScenarioActions.private.stopScenarioSuccess, (state, {id, responseDto}) => ({
    ...state,
    isLoading: false,
    error: null,
  })),

  on(ScenarioActions.private.stopScenarioFailure, (state, {error}) => ({
    ...state,
    isLoading: false,
    error,
  })),

  on(ScenarioActions.public.scenarioStartedFromWebSocket, (state, {scenarioId, displayName, startedAt, runtimeMinutes}) => ({
    ...state,
    runningScenario: {scenarioId, displayName, startedAt, runtimeMinutes},
  })),

  on(ScenarioActions.public.scenarioStoppedFromWebSocket, (state, {scenarioId}) => ({
    ...state,
    runningScenario: state.runningScenario?.scenarioId === scenarioId ? null : state.runningScenario,
  })),
);
